'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var Checkbox = require('./Checkbox');
var includes = require('lodash/includes');

var CheckboxGroup = function (_React$Component) {
  _inherits(CheckboxGroup, _React$Component);

  function CheckboxGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CheckboxGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function (value, checked) {
      var values = _this.props.options.filter(function (option) {
        if (option.value === value) {
          return checked;
        }

        return includes(_this.props.values, option.value);
      }).map(function (option) {
        return option.value;
      });

      _this.props.onChange(values);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CheckboxGroup.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      'div',
      { className: 'cf-checkbox__group' },
      this.props.options.map(function (option) {
        return React.createElement(Checkbox, {
          key: option.name,
          label: option.label,
          name: option.name,
          value: option.value,
          checked: includes(_this2.props.values, option.value),
          onChange: function onChange(val) {
            return _this2.handleChange(option.value, val);
          } });
      })
    );
  };

  return CheckboxGroup;
}(React.Component);

CheckboxGroup.propTypes = {
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]).isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired
};


module.exports = CheckboxGroup;